import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { HomeOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Result
        status="404"
        title={t('notFoundTitle')}
        subTitle={t('notFoundSubtitle')}
        extra={
          <div className="space-x-2">
            <Button 
              type="primary" 
              icon={<HomeOutlined />}
              onClick={() => navigate('/dashboard')}
            >
              {t('notFoundBackDashboard')}
            </Button>
            <Button 
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate(-1)}
            >
              {t('notFoundGoBack')}
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default NotFoundPage;
